var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrbitTool(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 135.47 135.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radialGradient4594",
    cx: 52.705,
    cy: 259.43,
    r: 36.918,
    gradientTransform: "matrix(.96682 -.25547 .75764 2.8673 18.946 -405.32)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.86735,
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,-161.53)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m251.4 239.43-3.8633 0.15658s1.8215 4.8371 4.2276 11.794l2.9233-0.65887c-2.4355-8.2321-3.2877-11.291-3.2877-11.291zm6.9236 23.475-2.5549 0.51831c1.0918 3.4303 2.1773 6.9786 3.174 10.482 0.21045 0.73969 0.4108 1.4738 0.60668 2.205l2.4841-0.82786c-0.21455-0.75953-0.43439-1.521-0.66611-2.2862-1.1425-3.7728-2.131-7.0527-3.0437-10.091zm6.5257 24.463-2.6267 0.59944c0.80252 4.3594 1.3624 8.4436 1.7477 12.148l2.6246-0.56276c-0.38074-3.7515-0.94005-7.8561-1.7456-12.185zm-0.20826 21.851c0.30741 7.1487-0.0424 11.485-0.0424 11.485l2.5704-0.0227c0-2e-3 0.35483-4.3785 0.0982-11.428z",
    fill: "url(#radialGradient4594)",
    stroke: "#fff",
    strokeWidth: ".26458px"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.04,
    y: 227.15,
    width: 46.801,
    height: 98.86,
    fill: "#ababab",
    stroke: "#fff",
    strokeOpacity: 0.86735,
    strokeWidth: 1.5668
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.58239 0 0 1 235.11 48.302)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.189,
    y: 190.06,
    width: 7.2163,
    height: 19.778
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.189,
    y: 220.42,
    width: 7.2163,
    height: 19.778
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.189,
    y: 250.78,
    width: 7.2163,
    height: 19.778
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(213.1 48.302)",
    stroke: "#000",
    strokeWidth: ".25667px"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m62.801 259.12s44.783-54.255 48.351-58.399c3.5684-4.1445 8.2072-8.6657 10.883-5.2748 2.4978 3.0142 0.35684 6.2167-4.1036 11.491-0.73066 0.91175-7.6931 9.3173-16.146 19.51-14.252 17.186-32.741 39.454-32.741 39.454-1.4934-9.4454-0.92079-3.7688-6.2446-6.7819z",
    fill: "#51594e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.664 273.44 13.381-7.5354-1.4273-5.4632-4.8173-1.3187z",
    fill: "#f3f097"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.664 273.44 2.6763-4.898 2.141 2.2606z",
    fill: "#040405"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 68.191,
    cy: 229.62,
    rx: 25.572,
    ry: 26.789,
    fill: "#ababab"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(90 27.215 315.33)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-50.991 285.63c5.8855-0.50737 30.881-4.4687 31.153-12.786 0.25369-7.7628-26.728-12.499-43.127-12.329-23.433 0.24226-43.33 5.5304-43.228 12.634 0.10147 7.1032 18.164 10.553 18.164 10.553l-5.0737-8.1687",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2.3813
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-85.581 285.35-11.319 4.13-0.79411-2.2177 9.2736-3.4395z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m93.779 229.71a23.441 25.978 0 0 0-23.086-25.958v51.922a23.441 25.978 0 0 0 23.086-25.964z",
    fill: "#ababab"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128.31 -47.49)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-50.991 285.63c5.8855-0.50737 30.881-4.4687 31.153-12.786 0.25369-7.7628-26.728-12.499-43.127-12.329-23.433 0.24226-43.33 5.5304-43.228 12.634 0.10147 7.1032 18.164 10.553 18.164 10.553l-5.0737-8.1687",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2.3813
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-85.581 285.35-11.319 4.13-0.79411-2.2177 9.2736-3.4395z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m68.621 203.39a24.962 23.544 0 0 0-24.943 23.187h49.892a24.962 23.544 0 0 0-24.949-23.187z",
    fill: "#ababab"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrbitTool);
export default __webpack_public_path__ + "static/media/orbit_tool.8285c9ea458678d6ef9f18091f4700ff.svg";
export { ForwardRef as ReactComponent };